/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookDto from './BookDto';
import CustomerShoppingCartBookListBookCartDto from './CustomerShoppingCartBookListBookCartDto';

/**
 * The CustomerShoppingCartBookListBookDto model module.
 * @module model/CustomerShoppingCartBookListBookDto
 * @version v1.0.0
 */
class CustomerShoppingCartBookListBookDto {
    /**
     * Constructs a new <code>CustomerShoppingCartBookListBookDto</code>.
     * @alias module:model/CustomerShoppingCartBookListBookDto
     */
    constructor() { 
        
        CustomerShoppingCartBookListBookDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomerShoppingCartBookListBookDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomerShoppingCartBookListBookDto} obj Optional instance to populate.
     * @return {module:model/CustomerShoppingCartBookListBookDto} The populated <code>CustomerShoppingCartBookListBookDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomerShoppingCartBookListBookDto();

            if (data.hasOwnProperty('book')) {
                obj['book'] = BookDto.constructFromObject(data['book']);
            }
            if (data.hasOwnProperty('cartItem')) {
                obj['cartItem'] = CustomerShoppingCartBookListBookCartDto.constructFromObject(data['cartItem']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/BookDto} book
 */
CustomerShoppingCartBookListBookDto.prototype['book'] = undefined;

/**
 * @member {module:model/CustomerShoppingCartBookListBookCartDto} cartItem
 */
CustomerShoppingCartBookListBookDto.prototype['cartItem'] = undefined;






export default CustomerShoppingCartBookListBookDto;

